import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';
import { CreateCrisisRecoveryActivitySchema, UpdateCrisisRecoveryActivitySchema } from '@repo/contracts';

export class CrisisRecoveryActivitiesService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getAll(params = {}) {
        try {
            const response = await withRetry(() => this.api.getAll(params), { maxRetries: 2 });
            return {
                success: true,
                data: response.data,
                pagination: response.pagination || response.meta || {},
                message: response.message || 'Recovery activities listesi getirildi'
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch crisis recovery activities');
        }
    }

    async getById(id) {
        try {
            const response = await withRetry(() => this.api.getById(id), { maxRetries: 2 });
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch crisis recovery activity');
        }
    }

    async create(data) {
        const validation = CreateCrisisRecoveryActivitySchema.safeParse(data);
        if (!validation.success) throw ApiError.validation('Invalid data', validation.error);

        try {
            const response = await this.api.create(validation.data);
            return {
                success: true,
                data: response.data,
                message: response.message || 'Recovery activity oluşturuldu'
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to create crisis recovery activity');
        }
    }

    async update(id, data) {
        const validation = UpdateCrisisRecoveryActivitySchema.safeParse(data);
        if (!validation.success) throw ApiError.validation('Invalid data', validation.error);

        try {
            const response = await this.api.update(id, validation.data);
            return {
                success: true,
                data: response.data,
                message: response.message || 'Recovery activity güncellendi'
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to update crisis recovery activity');
        }
    }

    async delete(id) {
        try {
            const response = await this.api.delete(id);
            return { success: true, data: response.data, message: response.message || 'Recovery activity silindi' };
        } catch (error) {
            throw this._handleError(error, 'Failed to delete crisis recovery activity');
        }
    }

    async batchDelete(ids) {
        try {
            const response = await this.api.batchDelete(ids);
            return {
                success: true,
                deletedCount: response.deletedCount ?? response.data?.deletedCount ?? 0,
                message: response.message || response.data?.message || `${ids.length} öğe silindi`
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to batch delete crisis recovery activities');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
